import { render, staticRenderFns } from "./siteHeader.vue?vue&type=template&id=5f2111c8&scoped=true"
import script from "./siteHeader.vue?vue&type=script&lang=js"
export * from "./siteHeader.vue?vue&type=script&lang=js"
import style0 from "./siteHeader.vue?vue&type=style&index=0&id=5f2111c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2111c8",
  null
  
)

export default component.exports